module.exports = __webpack_public_path__ + "img/game_phone_yn.55b71d64.png";